import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { MapView } from '../components/map';

// PUBLIC map — no login. The field-capture tool links here so the crew can
// review their work (?project=&site=&evidence=<id> flies to a capture).
// This exposes no data that wasn't already public: every endpoint MapView
// reads (boundary, artifacts, evidence, annotations, exports) is a
// deliberately token-less read; only the /project/* shell was auth-gated.
export default function PublicMapPage() {
  const [sp] = useSearchParams();
  const projectCode = sp.get('project') || 'TUSCANY';
  const siteCode = sp.get('site') || null;
  const [proj, setProj] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    fetch('/api/access/projects')
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('projects fetch failed'))))
      .then((j) => {
        const p = (j.projects || []).find((x) => x.code === projectCode);
        if (!p) throw new Error('unknown project');
        setProj(p);
      })
      .catch(() => setFailed(true));
  }, [projectCode]);

  if (failed) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ height: '100vh' }}>
        <Typography color="text.secondary">Map unavailable — unknown project “{projectCode}”.</Typography>
      </Stack>
    );
  }
  if (!proj) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ height: '100vh' }}>
        <CircularProgress />
      </Stack>
    );
  }
  const site = siteCode ? (proj.sites || []).find((s) => s.code === siteCode) : null;
  return (
    <>
      <Helmet><title> Map | TERRRA </title></Helmet>
      <Box sx={{ position: 'fixed', inset: 0 }}>
        <MapView
          key={`${projectCode}-${siteCode || ''}`}
          projectCode={projectCode}
          projectId={proj.id}
          siteCode={site ? site.code : undefined}
          siteId={site ? site.id : undefined}
        />
      </Box>
    </>
  );
}
